module.exports = __webpack_public_path__ + "img/dr_vivek_photo.765f9121.png";